/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Conf_LowInputs */

const cs_addr_conf_low = /** @type {(inputs: Addr_Conf_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nízká`)
};

const en_addr_conf_low = /** @type {(inputs: Addr_Conf_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low`)
};

/**
* | output |
* | --- |
* | "Low" |
*
* @param {Addr_Conf_LowInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_conf_low = /** @type {((inputs?: Addr_Conf_LowInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Conf_LowInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_conf_low(inputs)
	return cs_addr_conf_low(inputs)
});